import React from 'react'
import { connect } from 'react-redux'
import Box from '../../../core/components/box/Box'
import Text from '../../../core/components/typography/text/Text'
import {TextInput} from '../../../core/components/input'
import {SecondaryButton} from '../../../core/components/unilink/index'
import {withNav} from '../../../core/components/navbar/index'
import GridContainer from '../../../core/components/gridcontainer/GridContainer'
import {post} from '../../../util/http'
import {showToast} from '../../../redux/modules/toast'

class ResetPassword extends React.PureComponent{
  constructor(props) {
    super(props)
    this.state = {
      password: ''
    }

    this.formSubmitted = this.formSubmitted.bind(this)
    this.updatePassword = this.updatePassword.bind(this)
  }

  componentDidMount() {

  }

  updatePassword(e) {
    e.preventDefault()
    this.setState({password:e.target.value})
  }

  formSubmitted(e) {
    e.preventDefault()
    const {code, email, showToast} = this.props
    const {password} = this.state
    post('/api/session/reset_password_via_code', {
      code: code,
      email: email,
      new_password: password,
    }).then(response => {
      this.props.history.push('/')
      window.location.reload()
    }).catch(response => {
      showToast(response.error_message)
    })
  }

  render() {
    const {className} = this.props
    return (
      <div className={className}>
        <GridContainer>
          <form className='pageable-modal expii-form' onSubmit={ this.formSubmitted }>
            <Box
              display='flex'
              direction='column'
              alignItems='center'
              height='8rem'
              marginTop={8}
              justifyContent='between'>
              <Text fontWeight='book'>
                  You're almost there! Just pick a new password and you'll be logged in.
              </Text>
              <TextInput
                onChange={this.updatePassword}
                placeholder='password'
                type='password'
                pattern='.{6,}'
                title="Passwords must be at least 6 characters long"
                required />
              <div className='loginAndRegister-form__buttons'>
                <SecondaryButton
                  disabled={this.state.password.length < 6}
                  type='submit'>
                    Reset Password
                </SecondaryButton>
              </div>
            </Box>
          </form>
        </GridContainer>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  showToast: message => dispatch(showToast(({
    'text': message,
    'timeout': 5000
  })))
})

export default connect(null, mapDispatchToProps)(withNav(ResetPassword))



// WEBPACK FOOTER //
// ./src/domains/misc/components/ResetPassword.js